import React from 'react'
import AddDefectForm from '../../../component/form/master/defect/AddDefectForm'

export default function AddDefect() {
    return (
        <>
            <div className='container-fluid'>
                <div className="row">
                    <div className="col-md-12">
                        <AddDefectForm />
                    </div>
                </div>
            </div>
        </>
    )
}
